<template>
    <div class="content-wrap">
        <Toast/>
        <Dialog v-model:visible="showDialog" :header="selectedAlarmTitle" modal>
            <div v-html="selectedAlarmContent"></div>
        </Dialog>
        <div class="table-responsive table-list">
            <DataTable v-model:selection="state.selectedRow" :value="state.gridRowData" selectionMode="multiple"
                dataKey="al_seq" paginator :rows="20" 
                :rowsPerPageOptions="[10, 20, 50, 100, 200]"
                @rowSelect="onRowSelect" scrollable scrollHeight="400px"
                :rowClass="rowClass">
                <template #empty>
                    <div class="center">데이터가 존재하지 않습니다.</div>
                </template>
                <Column>
                    <template #header>
                        <ElCheckbox v-model="allCheck"/>
                    </template>
                    <template #body="{ data }">
                        <ElCheckbox 
                        v-model="state.selectedRow" 
                        :value="data.al_seq"
                        />
                    </template>
                </Column>
                <Column v-for="alarm of state.gridColumn" :key="alarm" :field="alarm.field" :header="alarm.headerName"
                    sortable :style="alarm.style" ref="removeColumn"
                >
                    <template #body="{ data, field }">
                        <span v-if="alarm.field == 'content'" v-bind:title="data.content">{{ getSummaryData(data.content) }}</span>
                        <span v-else>{{ data[field] }}</span>
                    </template>
                </Column>
            </DataTable>
        </div>

        <div class="text-end py-3">
            <ElButton type="primary" @buttonClick="deleteRow()">삭제</ElButton>
        </div>
    </div>
</template>

<script setup>
import { reactive, onMounted, ref, computed ,nextTick} from 'vue'
import { useRouter } from "vue-router";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { useToast } from "primevue/usetoast";
import Toast from 'primevue/toast';
import { useUserStore } from '@/store/user'
import { useMyAlarmStore } from '@/store/myalarm';
import Dialog from 'primevue/dialog';
const userStore = useUserStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { myAlarmList, myAlarmEdit ,myAlarmReadEdit} from '@/api/alarm';

const toast = useToast();
const router = useRouter();
const removeColumn = ref()
const myAlarmBellStore = useMyAlarmStore()
const showDialog = ref(false);
const selectedAlarmContent = ref('');
const selectedAlarmTitle = ref('');

onMounted(() => {
    getDataList()
})
const onRowSelect = (alarm) => {
    updateAlarm(alarm)
    const gridAlarm = alarm.data
    const selectDataList = state.getDataList.find(r => r.al_seq === gridAlarm.al_seq)
    if(selectDataList){
        nextTick(() => {
            selectedAlarmContent.value = selectDataList.content;
            selectedAlarmTitle.value = selectDataList.title;
            showDialog.value = true;
        });
    }
        
    // todo 클릭했을 때 y 값을 넘겨서 데이터를 다시 불러와야 한다. api 없음
    // toast.add({ severity: 'success', summary: '알람 조회 내용', detail: alarm.data.content });
};


const state = reactive({
    gridColumn: [
        //width 로 각 셀 크기 조절 가능
        { headerName: '열람여부', field: "read_yn", style: { minWidth: '50px' } }, 
        { headerName: '내용', field: "content", style: { minWidth: '50px' } },
        { headerName: '영업대표', field: "sales_ceo", style: { minWidth: '50px' } },
        { headerName: '등록일', field: "fmt_reg_dt", style: { minWidth: '150px' } },
    ],
    //백에서 받아와서 보여줄 list 데이터
    gridRowData: [],
    selectedRow: [],
    getDataList: [],
    searchParams: {
        read_yn: '',
        page_count: 1,
        unit_count: 100000,
    },
    updateParams: {
        ss_user_id: userStore.user.employeeId,
        al_seq: ''
    }
})
/* row 스타일 적용 */
const rowClass = (data) => {
  return [{ 'p-highlight': data.read_yn === 'Y' }]; //알림여부 Y일때 스타일 적용
};

const allCheck = computed({
    get() {
        return state.gridRowData.length === state.selectedRow.length;
    },
    set(newValue) {
        state.selectedRow = newValue ? state.gridRowData.map((item) => { return item.al_seq }) : [];
    }
})

const getDataList = async () => {
    try {
        setIsLoading(true)
        const regex = /(<([^>]+)>|&nbsp;)/ig;
        const res = await myAlarmBellStore.myAlarmListData()
        state.getDataList = [... res.rtn]
        state.gridRowData = res.rtn.map(item => ({
            ...item, // 기존 속성 유지
            content: item.content.replace(regex, '') // HTML 태그 제거
        }));
    } catch (err) {
        console.log('/alarm/myAlarmList ERROR!! => ' + err)
        alert('api 에러 발생!!')
    } finally {
        setIsLoading(false)
    }
}

const updateAlarm = async (alarm) => {
    try {
        setIsLoading(true)
        let params = {
            al_seq: alarm.data.al_seq,
            ss_user_id: userStore.user.employeeId
        };
            
        await myAlarmReadEdit(params)
        await getDataList() // 데이터 가져오기
    
    } catch (err) {
        console.log('error', err)
    } finally {
        setIsLoading(false)
    }
}


const getMyAlarmList = async () => {
  try{ 
   
    
  }catch(error){
    console.log(error)
  }
}


const getSummaryData = (item) => {

    let summaryData = item.length > 80 ? item.slice(0, 80) + " ..." : item;

    return summaryData
}

const searchTitle = async () => {
    await getDataList()
}

const deleteRow = async () => {
    if (confirm("선택하신 항목을 삭제 하시겠습니까?") == true) {

        let selectRows = state.selectedRow

        if (selectRows && selectRows?.length > 0) {
            for (let rows of selectRows) {
                let params = {
                    al_seq: rows,
                    del_yn: 'Y',
                    ss_user_id: userStore.user.employeeId
                };
                try {
                    setIsLoading(true)
                    const res = await myAlarmEdit(params)
                    await getDataList() // 데이터 가져오기
                } catch (err) {
                    console.log('error', err)
                } finally {
                    setIsLoading(false)
                }
            }

            alert(selectRows.length + '건 삭제완료!!')
        }
        else {
            alert('선택된 행이 없습니다.')
        }
    }
}

</script>